/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      backgroundColor: 'green',
    },
    content: {
      position: 'relative',
      width: '900px',
      height: '700px',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
      overflowY: 'hidden',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    footerBtn: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '10px',
      paddingBottom: '10px',
      width: '800px',
      position: 'fixed',
      bottom: 0,
      zIndex: 10,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    closeIconContainer: {
      position: 'absolute',
      right: -5,
      top: -5,
      color: '#737373',
      cursor: 'pointer',
    },
    tabContent: {
      marginTop: '24px',
      marginBottom: '1em',
      minHeight: '320px',
      height: 'calc(100% - 156px)',
      overflowY: 'auto',
      scrollbarColor: '#888888 transparent',
      [theme.breakpoints.down('sm')]: {
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollbarColor: 'unset',
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(3),
      columnGap: '10px',
    },
    titleView: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '& p:last-child': {
        color: theme.palette.grey[800],
      },
    },
    titleText: {
      weight: 600,
      fontSize: '24px',
      color: '#01195B',
    },
    resourceTitleText: {
      fontWeight: 700,
      fontSize: '16px',
      color: '#434E61',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: '9px',
        paddingLeft: '14px',
        paddingTop: '2px',
      },
    },
    agencyNameText: {
      fontWeight: 700,
      fontSize: '16px',
      color: '#23272E',
    },
    detailsLabelText: {
      fontWeight: 400,
      fontSize: '14px',
      color: '#64748B',
      paddingRight: '8px',
    },
    detailsText: {
      fontWeight: 400,
      fontSize: '14px',
      color: '#23272E',
      whiteSpace: 'normal',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        textAlign: 'right',
      },
    },
    commentsText: {
      fontWeight: 400,
      fontSize: '14px',
      color: '#23272E',
      whiteSpace: 'normal'
    },
    contactBox: {
      display: 'flex',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('md')]: {
        marginLeft: '-8px',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    grayBox: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1),
      backgroundColor: theme.palette.grey[50],
      '& .MuiBox-root': {
        display: 'flex',
        justifyContent: 'flex-end',
        color: theme.palette.grey[800],
      },
    },
    stackView: {
      backgroundColor: theme.palette.grey[50],
    },
    contentStackView: {
      backgroundColor: '#fefefe',
      border: '0',
      marginBottom: '24px',
      marginRight: '2px',
      borderRadius: '12px',
      paddingTop: '12px',
      paddingLeft: '16px',
      paddingRight: '16px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '8px',
        paddingRight: '8px',
        marginRight: 0,
      },
    },
    sectionItem: {
      '& .MuiBox-root': {
        backgroundColor: theme.palette.grey[100],
        fontSize: '11px',
        fontWeight: 600,
        color: theme.palette.grey[700],
      },
    },
    headerGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: theme.spacing(1),
    },
    rightColGroup: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
    wrapCenter: {
      display: 'flex',
      alignItems: 'center',
      paddingRight: theme.spacing(1),
    },
    title: {
      color: theme.palette.grey[700],
      padding: '0 12px',
    },
    requestCount: {
      color: theme.palette.common.black,
    },
    acceptCount: {
      color: theme.palette.grey[700],
    },
    requestAcceptWrapperBox: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'right',
      },
    },
    requestAcceptBox: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #E3E7EA',
      borderRadius: '4px',
      padding: '4px 6px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    requestAcceptLabel: {
      fontWeight: 400,
      fontSize: '16px',
      color: '#5D5D5F',
      paddingRight: '8px',
      whiteSpace: 'nowrap',
    },
    requestAcceptText: {
      fontWeight: 700,
      fontSize: '16px',
      color: '#01195B',
    },
    detailItem: {
      marginBottom: theme.spacing(1),
      padding: '8px',
      borderRadius: theme.spacing(1),
      backgroundColor: '#ffffff',
    },
  };
});

const TabsStyles = (theme: Theme): any => ({
  root: {
    display: 'flex',
    alignItems: 'left',
  },
  indicator: {
    backgroundColor: 'transparent',
    // backgroundColor: 'orange',
  },
  title: {
    color: '#5D5D5F',
    paddingRight: theme.spacing(1),
    '& .Mui-selected': {
      color: theme.palette.common.white,
    },
  },
});

const TabItemStyles = (theme: Theme): any => ({
  root: {
    opacity: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 0,
    backgroundColor: 'transparent',
    textTransform: 'none',
    marginRight: '10px',
  },
});

export { TabsStyles, TabItemStyles };

export default useStyles;
